"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLogging = void 0;
/* eslint-disable func-names */
const logger_1 = require("../logger");
function withLogging(obj) {
    function logDuration(methodName, startTime, args) {
        const duration = Date.now() - startTime;
        logger_1.logger.trace({ args }, `${methodName} executed in ${duration}ms`);
    }
    const wrappedObj = new Proxy(obj, {
        get(target, prop) {
            const originalMethod = target[prop];
            if (typeof originalMethod === 'function') {
                return async function (...args) {
                    const startTime = Date.now();
                    const result = await originalMethod.apply(target, args);
                    logDuration(String(prop), startTime, args);
                    return result;
                };
            }
            return originalMethod;
        },
    });
    return wrappedObj;
}
exports.withLogging = withLogging;
//# sourceMappingURL=index.js.map